import axios from 'axios';

// REACT_APP_API_URL берётся из .env
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Request interceptor: добавляем заголовок Authorization, если токен есть в localStorage
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');

    if (token && !config.headers?.Authorization) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor: при 401 пытаемся обновить access-token
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      // Если попытка обновления токена на /auth/refresh не удалась – очищаем данные и редиректим на логин
      if (originalRequest.url === '/auth/refresh') {
        localStorage.removeItem('user');
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('participant_id');
        window.location.href = '/login';
        return Promise.reject(error);
      }
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers['Authorization'] = 'Bearer ' + token;
            return api(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }
      originalRequest._retry = true;
      isRefreshing = true;
      const refresh_token = localStorage.getItem('refresh_token');
      return new Promise((resolve, reject) => {
        api
          .post('/auth/refresh', null, { headers: { Authorization: `Bearer ${refresh_token}` } })
          .then(({ data }) => {
            localStorage.setItem('access_token', data.access_token);
            originalRequest.headers['Authorization'] = 'Bearer ' + data.access_token;
            processQueue(null, data.access_token);
            resolve(api(originalRequest));
          })
          .catch((err) => {
            processQueue(err, null);
            localStorage.removeItem('user');
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('participant_id');
            window.location.href = '/login';
            reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }
    return Promise.reject(error);
  },
);

// Шумный лог для 4xx/5xx, чтобы увидеть точный URL/заголовки
api.interceptors.response.use(
  (r) => r,
  (err) => {
    try {
      const res = err?.response;
      const req = err?.config;
      if (res) {
        console.warn(
          '[AXIOS]',
          res.status,
          res.statusText,
          'URL:',
          res.config?.url,
          'baseURL:',
          res.config?.baseURL,
        );
        console.warn('[AXIOS] responseURL:', res.request?.responseURL);
        console.warn('[AXIOS] headers:', res.headers);
      } else if (req) {
        console.warn('[AXIOS] network/other error for', req.baseURL + req.url);
      }
    } catch (e) {
      // Intentionally ignore logging errors (do not break the request pipeline)
    }
    return Promise.reject(err);
  },
);

export default api;
